import httpService from "../../components/service";

export const wishlist = {
    namespaced: true,
    state: {
        lists: [],
        toAddList: [],
        display: false,
        displayAddList: false,
        book: {},
        mode: "add",
        wishList: {}
    },
    getters: {
        getLists(state) {
            return state.lists;
        },
        getToAddList(state) {
            return state.toAddList;
        },
        isDisplay(state) {
            return state.display;
        },
        isDisplayAddList(state) {
            return state.displayAddList;
        },
        getBook(state) {
            return state.book;
        },
        getMode(state) {
            return state.mode;
        }
    },
    mutations: {
        SEARCH_LIST(state, lists) {
            state.lists = lists;
        },
        TO_ADD_LIST(state, compoennt) {
            state.toAddList.push(compoennt);
        },
        ADD_LIST(state, list) {
            state.lists.push(list);
        },
        SET_DISPLAY(state, display) {
            state.display = display;
        },
        SET_DISPLAY_ADD_LIST(state, display) {
            state.displayAddList = display;
        },
        CLEAN_TO_ADD_LIST(state) {
            state.toAddList = [];
        },
        DELETE_LIST(state, list) {
            state.lists.splice(state.lists.indexOf(list), 1);
        },
        ADD_COMPONENTS_TO_LIST(state, list) {
            let components = state.toAddList;
            if (list.data === null || list.data instanceof Array || list.data === false) {
                list.data = {};
            }
            if (list.data.components instanceof Array === false) {
                list.data.components = [];
            }
            components.forEach(component => {
                list.data.components.push(component);
            });
        },
        DELETE_COMPONENT_TO_LIST(state, obj) {
            let component = obj.component;
            let list = obj.list;
            if (list.data && list.data.components instanceof Array) {
                list.data.components.splice(list.data.components.indexOf(component), 1);
            }
        },
        SAVE_LIST(state) {
            state.toAddList = [];
        },
        SET_BOOK(state, book) {
            state.book = book;
        },
        SET_MODE(state, mode) {
            state.mode = mode;
        }
    },
    actions: {
        searchList(context) {
            httpService.get("/wishlists?limit=1000").then(res => {
                if (res.status && res.status === 400) {
                    alert(res.message);
                } else {
                    let lists = res.data;
                    lists.forEach(list => {
                        if (list.data === null || list.data instanceof Array) {
                            list.data = {};
                        }
                    });
                    context.commit("SEARCH_LIST", lists);
                }
            });
        },
        toAddList(context, compoennt) {
            context.commit("TO_ADD_LIST", compoennt);
        },
        addList(context, list) {
            httpService.post("/wishlists", JSON.stringify(list)).then(res => {
                if (res.code === 400) {
                    alert(res.message);
                } else {
                    list.id = res[0];
                    context.commit("ADD_LIST", list);
                }
            });
        },
        setMode(context, mode) {
            context.commit("SET_MODE", mode);
        },
        setDisplay(context, display) {
            context.commit("SET_DISPLAY", display);
        },
        setDisplayAddList(context, display) {
            context.commit("SET_DISPLAY_ADD_LIST", display);
        },
        cleanToAddList(context) {
            context.commit("CLEAN_TO_ADD_LIST");
        },
        deleteList(context, list) {
            context.commit("DELETE_LIST", list);
            httpService.delete("/wishlists/" + list.id).then(res => {});
        },
        addComponentsToList(context, list) {
            context.commit("ADD_COMPONENTS_TO_LIST", list);
        },
        deleteComponentToList(context, obj) {
            context.commit("DELETE_COMPONENT_TO_LIST", obj);
        },
        saveList(context, list) {
            httpService.put("/wishlists/" + list.id, JSON.stringify(list)).then(res => {
                let result = true;
                if (res.status && res.status === 400) {
                    alert(res.message);
                    result = false;
                } else {
                    result = true;
                }
                context.commit("SAVE_LIST");
                return result;
            });
        },
        setBook(context, book) {
            context.commit("SET_BOOK", book);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/catalog/wishlist.js